// extracted by mini-css-extract-plugin
export default {"icon":"IconBrightness_icon__qyN5s"};